export default "__VITE_ASSET__CaO_unF$__"